const Overlay = () => (
  <div
    data-testid="Overlay"
    className="fixed top-0 left-0 w-full h-screen bg-[#000000aa] z-[1000]"
  />
);

export default Overlay;
